import { HttpClient } from 'aurelia-fetch-client';
import { ApiResponse } from '../models/api-response';
import { CalculateFeeRequest } from '../models/hpfApi';
import { ServiceResponse } from '../models/service-response';
import { State } from './global-state';
import { HPFServiceClient } from './hpfApi';

export class HpfFeeService extends HPFServiceClient {
	constructor(
		state: State,
		http: HttpClient,
	) {
		super(state, http);
	}

	calculateFee(request: CalculateFeeRequest): Promise<ServiceResponse> {
		return this.post('/fee', request)
			.then((apiResponse: ApiResponse) => {
				if (!apiResponse.isSuccessful) {
					try {
						return this.error(`Unable to calculate fee: ${apiResponse.getErrorMessage()}`);
					} catch (error) {
						if (apiResponse.errors && apiResponse.errors.length > 0) {
							return this.error(`Unable to calculate fee: ${apiResponse.errors[0]}`);
						}
						return this.error(`Unable to calculate fee`);
					}
				}
				return this.success('', apiResponse.value);
			});
	}
}
